import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScrollButtonDirective } from '../../shared/directives/scroll-button/scroll-button.directive';
import { ScrollButtonArrowDirective } from '../../shared/directives/scroll-button/scroll-button-arrow.directive';
import { ScrollButtonListDirective } from '../../shared/directives/scroll-button/scroll-button-list.directive';
import { MenuListRepository } from '../../shared/repositories/menu-list.repository';
import { MatIconModule } from '@angular/material/icon';
import { UIMenuCategoryDto } from '../../shared/interfaces/ui-menu-category-dto.interface';
import { ScrollListService } from 'src/app/services/scroll-list.sevice';

@Component({
    selector: 'app-menu-nav',
    templateUrl: './menu-nav.component.html',
    styleUrls: ['./menu-nav.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass, ScrollButtonListDirective, NgFor, ScrollButtonDirective, RouterLinkActive,
        RouterLink, ScrollButtonArrowDirective, AsyncPipe, MatIconModule]
})
export class MenuNavComponent {
  constructor(
    private menuRepository: MenuListRepository,
    private scrollListService: ScrollListService
  ) {}

  isShowModal: boolean = false;

  @Input() menuGroups: UIMenuCategoryDto[];

  activeCategorySlug$: Observable<string> = this.menuRepository.activeCategory$.pipe(
    map(category => category.slug)
  );
  activeCategoryIndex$: Observable<number> = this.menuRepository.activeCategoryId$.pipe(
    map(id => {
      for(let i = 0; i < this.menuGroups.length; i++) {
        if(this.menuGroups[i].id === id) {return i;}
      }
      return 0;
    }),
    shareReplay({refCount: true, bufferSize: 1})
  );

  setActiveCategory(id: string, index: number): void {
    this.menuRepository.setActiveCategory(id);
    this.isShowModal = false;
    this.scrollListService.setActiveIndex(index);
  }

  onCloseModal(): void {
    this.isShowModal = false
  }
}
